<template>
<div>
  <div class="wrapper" style="background-color: white;">
    <img src="/static/images/wx-share-logo.jpg" id='notice-share-logo' alt="" style="width:0px;height:0px;">
    <div v-show="loading" class="page-loading" style="width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px;">
      <div class="loading-box" style="box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%);">
        <div class="loading-img"></div>
      </div>
    </div>
    <!--结构化引导-->
    <div class="new-user-guide" v-show="loading === false && showguide === true" @click="hideNewUserGuide">
      <div class="guide-menu" @click="hideNewUserGuide"></div>
      <div class="guide-img">
        <img src="../../../static/images/new-user-guide.png" alt="">
      </div>
    </div>

    <!--目录-打开-->
    <div id="mulu" v-show="showmenu">
      <div class="toolsbar-mune-2" style="max-width: 640px;">
        <div class="toggle-menu-wrap-2" @click="toggleMenu">
              <!-- 打开目录 -->
          <span class="cancle-btn"></span>
        </div>
        <div class="header-menu-wrap-2">
          <span class="options clicked header-menu" style="height: 40px; line-height: 40px">目录</span>
        </div>
      </div>
      <!--目录 列表-->
      <div class="notice-menu">
        <div class="bottom-color" style="max-width: 640px;">
          <div class="left-side-page">
            <div class="catalog-cont">
              <ul>
                <li v-for="c in titles" :style="indentChild(c.code)" v-show="c.isshow">
                  <template v-if="c.code && c.code.split('.').length<=7">
                    <a href="javascript:;" :class="{'expand': c.code.split('.').length<=2}">
                      <span @click="showTitleChild(c)" :class="{'open-caret-right': c.code.split('.').length<=2, 'close-caret-right': c.code.split('.').length>2}" v-if="c.haschild && !c.showchild">
                      </span>
                      <span @click="showTitleChild(c)" :class="{'open-caret': c.code.split('.').length<=2, 'close-caret': c.code.split('.').length>2}" v-if="c.haschild  && c.showchild">                </span>
                      <span class="no-caret" v-if="!c.haschild"></span>
                          <!-- 打印文章标题 -->
                      <span class="caret-pad" @click="titleIntoView(c.code + '-0')" v-html="c.title"></span>
                    </a>
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
      <!--目录-关闭-->
    <div id="main-content" v-show="!showComments">
      <!--页眉-->
    <div class="beta_record" v-if="showUserInfo">
      <div class="photo_img"><img :src="headUrl"></div>
      <div class="wx_content">
        <p class="p1">{{xnName}}邀您阅读</p>
        <p class="p2">{{company}} | {{position}}</p>
      </div>
    </div>
      <div :class="[ showUserInfo ? 'toolsbar-mune':'toolsbar-mune-1']" @click="toggleTitle" v-show="!showmenu">
        <div class="toggle-menu-wrap" @click="toggleMenu" v-if="showNotice">
          <span class="sidebar-btn"></span>
        </div>
        <div class="toggle-menu-wrap" @click="backTotext()" v-if="!showNotice && (showPrevNext || annObject.length === 1)">
          <a class="footer-btn" style="position:relative;top:2px;right:0">返回</a>
        </div>
        <div class="notice-title blue"><strong id="detail-title">{{ detail.fulltitle | formatTitle }}</strong></div>
        <div class="header-toggle-icon" style="width: 100%; height: 20px;" v-if="detail.fulltitle.length > 33">
          <div class="toggle-icon toggle-down-arrow"></div>
        </div>
      </div>
      <!--主体-->
      <div :class="[showUserInfo ? 'my-container-1' : 'my-container-3']" style="" id="annotation" v-if="showNotice">
        <div class="notice-content" id="cont">
          <table class="table-title" v-show="!loading && showheadtable === 0 && (topPage == 1 || topPage == 0)" style="width: 94% !important;margin: 0 auto;margin-top: 10px">
            <tbody>
            <tr>
              <td colspan=4>{{ detail.fulltitle }}</td>
            </tr>
            <tr>
              <td class="blue">板块类型</td>
              <td> {{ categoryName(detail.category) }} </td>
              <td class="blue">发布日期</td>
              <td> {{ detail.publishDate }} </td>
            </tr>
            <tr>
              <td class="blue">证券简称</td>
              <td> {{ detail.company }} </td>
              <td class="blue">证券代码</td>
              <td>{{detail.companyCode}}</td>
            </tr>
            <!-- <tr>
              <td class="blue">公告类型</td>
              <td colspan=3> {{ detail.type }} </td>
            </tr>
            <tr>
              <td class="blue">公告标签</td>
              <td colspan=3> {{ detail.labels }} </td>
            </tr> -->
            </tbody>
          </table>

          <!-- <template v-for="(z,c) in detail.child" track-by="$index" v-if="$index <= pages * 5"> -->
          <template v-for="(z,c) in detail.child" track-by="$index" v-show="$index <= (bottomPage*5 - 1) && $index >= (topPage-1)*5-1">
            <!--显示标题-->
            <p class="title-a" id="{{c.code}}-0" :style="indentChild(c.code)" v-if="c.title && c.code.split('.').length === 2">{{c.title}}</p>
            <p class="title-b" id="{{c.code}}-0" :style="indentChild(c.code)" v-if="c.title && c.code.split('.').length === 3">{{c.title}}</p>
            <p class="title-b-2" id="{{c.code}}-0" :style="indentChild(c.code)" v-if="c.title && c.code.split('.').length > 3">{{c.title}}</p>

            <template v-for="(key,d) in c.contents">
              <!--显示段落-->
              <template v-if="d.htmltag=='p'">
                <div :id="idCompute(c,$index,z)" style="width: 94%;margin: 0 auto;">
                  <p class="title-c" v-for="content in d.content.split('\n')" track-by="$index">{{content}}</p>
                </div>
              </template>
              <!-- 显示研报图片 -->
              <template v-if="d.htmltag=='img'">
                <div :id="idCompute(c, $index, z)">
                  <p class="title-c" style="padding-left: 20px; text-indent: 2em;">{{d.imghead}}</p>
                  <img style="padding-left: 20px; text-indent: 2em;" src="{{d.imgurl}}" />
                  <p class="title-c" style="padding-left: 20px; text-indent: 2em;">{{d.imgfoot}}</p>
                </div>
              </template>
              <!--表格-->
              <div class="table-tory-outter" v-if="d.htmltag=='table'" :id="idCompute(c,$index,z)" style="width: 94%;margin: 0 auto; margin-top: 10px">
                <table cellpadding="0" class="table-tory">
                  <tbody>
                  <tr v-for="(rowidx, row) in d.content.split('\n')" track-by="$index" :class="{'oldcom': !(rowidx%2), 'evencom': rowidx%2}">
                    <td v-for="(colidx, col) in row.split('\t')" :id="idCompute(c, key, z) + '-' + rowidx + '-' + colidx" rowspan="{{ getrowspan(rowidx, colidx, d.mergecells) }}" colspan="{{ getcolspan(rowidx, colidx, d.mergecells) }}" track-by="$index">
                      {{col}}
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!--作为分享描述-->
                <p class="table-info" style="display: none">{{d.info}}</p>
              </div>
              <!-- <div class="table-tory-outter" v-if="d.htmltag=='table' && params.stype==2" id="{{c.code}}-{{$index+1}}" style="width: 94%;margin: 0 auto;">
                <table cellpadding="0" class="table-tory">
                  <tbody>
                  <tr v-for="(rowidx, row) in d.content.split('\n')" track-by="$index" :class="{'oldcom': !(rowidx%2), 'evencom': rowidx%2}">
                    <td v-for="(colidx, col) in row.split('\t')" track-by="$index">
                      {{col}}
                    </td>
                  </tr>
                  </tbody>
                </table>
                <p class="table-info" style="display: none">{{d.info}}</p>
              </div> -->
            </template>
          </template>


            <!-- 页面底部两张图片,以及二维码 -->
          <div class="code-a" v-if="!loading && bottomPage==allPageNum"><img src="/static/images/code-a.jpg"></div>
          <div class="code-b" v-if="!loading && bottomPage==allPageNum"><img src="/static/images/code-b.jpg"></div>
        </div>
      </div>
      <div class="my-container" style="top: 3px" id="annotation" v-if="!showNotice">
        <div class="notice-content" id="cont">
          <template v-for="(z,c) in newdetail" track-by="$index" >
            <!--显示标题-->
            <p class="title-a" id="{{c.code}}-0" :style="indentChild(c.code)" v-if="c.title && c.code.split('.').length === 2">{{c.title}}</p>
            <p class="title-b" id="{{c.code}}-0" :style="indentChild(c.code)" v-if="c.title && c.code.split('.').length === 3">{{c.title}}</p>
            <p class="title-b-2" id="{{c.code}}-0" :style="indentChild(c.code)" v-if="c.title && c.code.split('.').length > 3">{{c.title}}</p>

            <template v-for="(key,d) in c.contents">
              <!--显示段落-->
              <template v-if="d.htmltag=='p'">
                <div :id="idCompute(c,$index,z)" style="width: 94%;margin: 0 auto;">
                  <p class="title-c" v-for="content in d.content.split('\n')" track-by="$index">{{content}}</p>
                </div>
              </template>
              <!-- 显示研报图片 -->
              <template v-if="d.htmltag=='img'">
                <div :id="idCompute(c, $index, z)">
                  <p class="title-c" style="padding-left: 20px; text-indent: 2em;">{{d.imghead}}</p>
                  <img style="padding-left: 20px; text-indent: 2em;" src="{{d.imgurl}}" />
                  <p class="title-c" style="padding-left: 20px; text-indent: 2em;">{{d.imgfoot}}</p>
                </div>
              </template>
              <!--表格-->
              <div class="table-tory-outter" v-if="d.htmltag=='table'" :id="idCompute(c,$index,z)" style="width: 94%;margin: 0 auto; margin-top: 10px">
                <table cellpadding="0" class="table-tory">
                  <tbody>
                  <tr v-for="(rowidx, row) in d.content.split('\n')" track-by="$index" :class="{'oldcom': !(rowidx%2), 'evencom': rowidx%2}">
                    <td v-for="(colidx, col) in row.split('\t')" :id="idCompute(c, key, z) + '-' + rowidx + '-' + colidx" rowspan="{{ getrowspan(rowidx, colidx, d.mergecells) }}" colspan="{{ getcolspan(rowidx, colidx, d.mergecells) }}" track-by="$index">
                      {{col}}
                    </td>
                  </tr>
                  </tbody>
                </table>
                <!--作为分享描述-->
                <p class="table-info" style="display: none">{{d.info}}</p>
              </div>

            </template>
          </template>
        </div>
      </div>
    </div>


      <!-- 查看全部评论 目录列表关闭 -->
    <div class="my-container" v-show="showComments">
        <div class="comment-detail">
          <div class="comment-title">
           <p class="comment-all">全部评论</p> <!-- <a class="comment-my" href="javascript:;">我的评论</a>  -->
           <p class="comment-sort">{{cpwtotal}}条评论</p>
          </div>

          <div class="comment" v-for="item in commentList">
            <div class="common-avatar">
            <img src="/static/images/user.png" width="100%" height="100%">
          </div>

          <div class="comment-block">
            <p class="comment-user">
              <span class="comment-username" v-if="item.user"> {{item.user.username}} </span>
              <span class="comment-username" v-else> 匿名用户 </span>
            <span class="footer-zan"> <i class="c-share-icon" @click.stop="zan(item.id, $event)"></i><span class="u-num">{{item.zan_cnt}}</span></span>
            </p>

             <div class="comment-content">{{item.content}}
             </div>

             <div class="comment-operate">
                <span class="J_Vote comment-operate-item comment-operate-up">{{item.updtime | date}}</span>
                <span class="J_Reply comment-operate-item"> <a href="javascript:;" @click="commentinput = true, pid = item.id, content = ''">回复</a> </span>
            </div>
            <div class="comment-reply-ctn comment-reply-item" >
              <ul>
                <li v-for="i in item.replys" track-by="$index" v-if="$index < item.showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="i.user"> {{i.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{i.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up"><i class="c-share-icon" @click.stop="zan(i.id, $event)"></i><span>{{i.zan_cnt}}</span></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{i.updtime | date}}</span>
                    </div>
                </li>
                <!-- <li v-for="y in item.replys" track-by="$index" v-if="showall">
                  <p class="comment-text">
                    <span class="c-username" v-if="y.user"> {{y.user.username}} </span>
                    <span class="c-username" v-else>匿名用户</span>
                    {{y.content}}
                  </p>
                  <div class="reply-operate reply-operate-hot">
                      <span class="J_Vote reply-operate-item reply-up">赞<i class="staticAdd" @click.stop="zan(i.id, $event)">{{i.zan_cnt}}</i></span>
                        <span class="J_Reply reply-operate-item"></span>  <span>{{y.updtime | date}}</span>
                    </div>
                </li> -->

                <li class="view-more hidden" v-if="item.replys.length > 2 && item.showall !== 8">
                  <a class="btn-block text-center btn-comment-expand" @click="item.showall = 8">查看全部<span class="nume">{{item.replys.length}}</span>条回复  </a>
                </li>
              </ul>
              </div>
          </div>
          </div>
          </div>

          <div class="comment-more">
            <a href="javascript:;" v-if="commentList.length !== cpwtotal">加载更多评论中...</a>
            <a href="javascript:;" v-if="commentList.length == cpwtotal && cpwtotal !== 0">评论已全部加载</a>
          </div>

          <div class="comment-no" v-if="cpwtotal == 0">
          暂无评论，快来添加一个吧！
          </div>
          <div class="comment-no"></div>
        </div>



      <!--评论栏-->
    <div class="footer-comment" v-show="showNotice">
      <span class="footer-text">
        <a href="javascript:;" @click="commentinput = true, content= '',pid = 0">
          <i class="comment-icon"></i>评论一下</a>
      </span>
      <span class="footer-open" v-if="readORchange && showPrevNext">
        <span class="Shield-notes-btn" v-if="ModeOPtions == 1" @click="readMode()">屏蔽注解</span>
        <span class="notes-btn" v-if="ModeOPtions == 2" @click="readMode()">展开注解</span>
      </span>

      <span class="footer-top" @click="prevAnn()" v-if="showPrevNext && readORchange && ModeOPtions == 1">
        <i class="t-one-icon"></i>
      </span>
      <span class="footer-bot" @click="nextAnn()" v-if="showPrevNext && readORchange && ModeOPtions == 1">
        <i class="t-next-icon"></i>
      </span>
         <!-- 评论图标以及评论条数  点击查看全部评论  -->
      <span class="footer-zan" v-show="!showComments">
        <a href="javascript:;" @click="showComments = true, showPrevNext = false,loadcomment()">
          <span class="qinp"><i></i>{{cpwtotal}}</span>
        </a>
      </span>

         <!-- 查看全部评论，点击返回fixed 固定定位 -->
      <span class="footer-zan" v-show="showComments">
        <a href="javascript:;" @click="showComments = false, showPrevNext = true">
          <span class="text"><i></i>返回原文</span>
        </a>
      </span>
    </div>

     <!--评论弹窗-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;" v-show="commentinput" @click.self="commentinput = false">
      <div class="comment-content">
        <div class="comment-content-tag">
            <!-- 退出评论弹窗 -->
           <div class="login-close">
             <a class="delete-icon" href="javascript:;" @click="commentinput = false"></a>
          </div>
              <!-- 输入评论 -->
            <div class="comment-reply">
             <textarea cols="" rows="2" class="input-a" placeholder="输入发表内容" v-model="content"></textarea>
             <span class="anonymous" @click="anonym == 1 ? anonym = 0:anonym = 1">
                 <label class="el-checkbox mar">
                  <span class="el-checkbox-input" :class="{'is-checked':anonym === 1}">
                    <span class="el-checkbox-inner"></span>
                  </span>
                  <span class="el-checkbox-label">匿名评论</span>
                  </label>
               </span>
             <a class="btn-Publish" href="javascript:;" @click="commentinput = false,addComment(1, md5, params.stype, detail.publishDate)">发表</a>
            </div>
        </div>
      </div>
    </div>



    <div v-if="commentinput" class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all" id="ui-datepicker-div"></div>
      <!-- 背景阴影 -->
    <div v-if="commentinput" class="modal-backdrop fade in"></div>
    <!--页脚    底部页面下载应用-->
    <div class="footer-app">
      <a class="footer-logo-ios"></a>
      <span class="footer-text">IBDATA<br/>人工智能和大数据驱动的投研首选平台</span>
      <a class="footer-btn" @click="downloadApp">下载应用</a>
    </div>

    <!--微信绑定弹框-->
    <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" v-show="tipGoBind">
      <div class="binding-content">
        <a class="binding-logo"></a>
        <div class="binding-text">
          立即绑定IBDATA账号<br/>成为金融分析高手
        </div>
        <div class="binding-bot">
          <a class="binding-no-btn" @click="tipGoBind = false">暂不绑定</a>
          <a class="binding-btn" @click="goBindPage">立即绑定</a>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade in" v-show="tipGoBind"></div>
    <!-- / 微信绑定弹框-->
  </div>




  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" style="display: block;" v-if="seeAnnotation">
    <div class="subscribe-tag">
      <div class="zhushi-tag-cont">
        <div class="login-close">
           <a class="delete-icon" href="javascript:;" @click="seeAnnotation = false, editStatus = false"></a>
        </div>
        <div class="Notes-content">
        <div v-for="(key,item) in currentAnno" v-if="!editStatus">
        <div class="Notes-user">
             <span class="Notes-username"> {{annotationList[item[0]][3] }}</span><span class="Notes-time">{{annotationList[item[0]][4] }}</span>
        </div>
        <div class="subscribe-name" v-if="annotationList[item[0]][2] == 1 && annotationList[item[0]][0].length < 80">
          <span class="left">
              <span class="Notes-content-left">引用：</span>
              <span class="Notes-content-right">{{annotationList[item[0]][0]}}</span>
            </span>
        </div>
        <div class="subscribe-name" v-if="annotationList[item[0]][2] == 1 && annotationList[item[0]][0].length >= 80">
          <span class="left">
              <span class="Notes-content-left">引用：</span>
              <span class="Notes-content-right">{{annotationList[item[0]][0].substring(0, 80)}}...</span>
            </span>
          <span class="Notes-more" @click.self="spread($event)">展开<span class="Notes-triangle-b"></span></span>
        </div>
        <div class="subscribe-name" style="display:none;" v-if="annotationList[item[0]][2] == 1 && annotationList[item[0]][0].length >= 80">
          <span class="left">
              <span class="Notes-content-left">引用：</span>
              <span class="Notes-content-right">{{annotationList[item[0]][0]}}</span>
            </span>
          <span class="Notes-more" @click.self="retract($event)">收起<span class="Notes-triangle-a"></span></span>
        </div>

        <div class="subscribe-name" :class="{'name-a': annotationList[item[0]][1] == '#a5c5ff','name-c': annotationList[item[0]][1] == '#feb75e'}" v-if="annotationList[item[0]][2] == 2 &&annotationList[item[0]][0].length < 80">
          <span class="left">
              <span class="Notes-content-left">引用：</span>
              <span class="Notes-content-right">{{annotationList[item[0]][0]}}</span>
            </span>
        </div>
        <div class="subscribe-name" :class="{'name-a': annotationList[item[0]][1] == '#a5c5ff','name-c': annotationList[item[0]][1] == '#feb75e'}" v-if="annotationList[item[0]][2] == 2 &&annotationList[item[0]][0].length >= 80">
          <span class="left">
              <span class="Notes-content-left">引用：</span>
              <span class="Notes-content-right">{{annotationList[item[0]][0].substring(0, 80)}}...</span>
            </span>
          <span class="Notes-more" @click.self="spread($event)">展开<span class="Notes-triangle-b"></span></span>
        </div>
        <div class="subscribe-name" style="display:none;" :class="{'name-a': annotationList[item[0]][1] == '#a5c5ff','name-c': annotationList[item[0]][1] == '#feb75e'}" v-if="annotationList[item[0]][2] == 2 &&annotationList[item[0]][0].length >= 80">
          <span class="left">
              <span class="Notes-content-left">引用：</span>
              <span class="Notes-content-right">{{annotationList[item[0]][0]}}</span>
            </span>
          <span class="Notes-more" @click.self="retract($event)">收起<span class="Notes-triangle-a"></span></span>
        </div>
        <div class="box-content box-login Notes-content-a">
           <div class="Notes-list">

             <div class="Notes-content-a" v-if="annotationList[item[0]][2] == 1">
                <span class="left">
                  <span class="Notes-content-left">点评：</span>
                  <span class="Notes-content-right">{{{annotationList[item[0]][1]}}}</span>
                </span>
              </div>
             <!-- <div class="Notes-content" v-if="annotationList[item[0]][2] == 2"></div> -->
            <!-- <div class="Notes-operate" v-if="annotationList[item[0]][2] == 1">
              <a class="" @click="editStatus = true, changedIndex = key">编辑</a>
              <a class="" @click="delflag = true, del(item[0], key)">删除</a>
            </div> -->
          </div>
          </div>
          </div>

           <div class="box-textarea-block" v-if="editStatus">
            <textarea class="box-textarea J_Textarea" id="J_Textarea" placeholder="" v-model="currentAnno[changedIndex][1]"></textarea>
           </div>
           <div class="box-info" v-if="editStatus">
             <a class="box-commentBtn box-commentBtn--no J_PostBtn" @click="editStatus = false">
              取消编辑</a>
            <a class="box-commentBtn box-commentBtn--able J_PostBtn" @click="save(currentAnno[changedIndex][0], changedIndex)">
              保存</a>
           </div>
         </div>
        </div>
    </div>
  </div>
  <div class="ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all" id="ui-datepicker-div" v-if="seeAnnotation"></div>
  <div class="modal-backdrop fade in" v-if="seeAnnotation"></div>
 </div>
</template>

<script>
  import { apiUrl, alert } from '../../helper'
  import userMix from '../../common/userMix'
  import commentMix from './commentMix'
  // import comment from './comment'
  // import commentbody from './commentbody'
  // import commentalert from './commentalert'
  import $ from 'jquery'
  import wxshareMix from '../../common/wxshareMix'
  import noticeMix from '../../common/noticeMix'
  import searchMix from '../../common/SearchMix'

  export default {
    name: 'NoticeView',
    mixins: [userMix, commentMix, wxshareMix, noticeMix, searchMix],
    data () {
      return {
        md5: '',
        loading: false,
        detail: {},
        newdetail: [],
        tab1: 0,
        titles: [],
        heads: [],
        // showalltitle: false,
        id: null,         // id
        // showmenu: false,
        pages: 1,
        topPage: 0,    //上分页
        bottomPage: 0, //下分页
        allPageNum: 0, //总分页数
        showheadtable: null,
        allids: [],
        windowLocation: '',   // 当前页面location
        selection: null,
        range: null,
        startNode: null,
        endNode: null,
        startOffset: 0,
        endOffset: 0,
        flag: false,
        annotationList: {},
        addAnnotation: false,
        seeAnnotation: false,
        // 新增的注释
        annotationContent: '',
        currentAnno: [],
        editStatus: false,
        changedContent: '',
        changedID: '',
        changedIndex: null,
        startpos: 0,
        endpos: 0,
        // 获取到的注解对象
        annObject: [],
        delflag: false,
        curAnId: '',
        savedContent: '',
        annTyp: null,
        idstart: '',
        idend: '',
        idStartNode: null,
        idEndNode: null,
        Annconfig: ['1','2'],
        readORchange: false,
        ModeOPtions: 1,
        currentIndex: '',
        showPrevNext: false,              //注解全部加载
        categoryMap: {'A': 'A股', 'N3B': '新三板', 'ChinaBond': '债券', 'weixin': '知识库', 'IRM': '投资者问答'},
        showNotice: false,           // 注解页面和公告正文页面间切换状态
        annList: [],
      }
    },
    ready () {
      if (this.hideFooter) {
        $('footer.footer').css({'display': 'none'})
      }
      $('.wrapper').css('min-height', $(document).height()-100)
      document.getElementById('annotation').addEventListener('click', this.annotation)
      // $('.comment-detail').css({'height': $(window).height() * 0.8, 'overflow': 'scroll'})
    },
    created () {
      $('meta')[2].content = 'width=device-width, initial-scale=1'
    },
    route: {
      data ({ to }) {
        if (!this.currentuser) {
          this.wxcode = this.getQueryString('code')  // 获取微信登录code
          if (this.wxcode) {
            this.wxlogin(this.wxcode)
          } else {
            this.getProfile(to.query)
          }
        }
        if (this.currentuser) {
          console.log(to.query)
          console.log('输入打印 to tcode')
          this.params.id = to.params.id
          this.params.stype = to.query.stype
          this.params.tcode = to.query.tcode
          this.params.pdate = to.query.pdate
          this.params.idxname = to.query.idxname
          this.params.uidUrl = to.query.uid
          this.params.share = to.query.share
          this.params.plat = to.query.plat
          this.params.ts = to.query.ts
          this.params.sid = to.query.sid
          this.params.ruid = to.query.ruid
          this.params.forceupd = to.query.forceupd
          // this.params.desc = to.query.desc
          let descs = window.location.href.split('&')
          for (var i=0,len=descs.length; i<len; i++) {
            let str = descs[i]
            if (str.indexOf('desc=') == 0) {
              // this.params.desc = decodeURI(str.split('=')[1])
              this.params.desc = decodeURIComponent(str.split('=')[1])
              break;
            }
          }
          if (to.query.ext) {
            this.params.ext = parseInt(to.query.ext)
          }
          if (to.query.pid) {
            this.params.pid = to.query.pid
          }
          if (to.query.ccode) {
            this.params.ccode = to.query.ccode
          }
          this.titles = []
          this.heads = []
          this.getAnn(to.query.shareann)
          // this.getDetail(to.query.shareann)


          // ===================================================================================
          let that = this
          jQuery(window).bind('scrollstop', function () {
            console.log('滚动事件结束')
            // that.cpwpage = that.cpwpage + 1
            // if (that.cpwpage <= Math.ceil(that.cpwtotal / 10)) {
            //   that.getCommentList(1, that.params.id)
            // }
            let _allId = that.getAllId( that.allids )                // 1. 获取所有ID
            let itemID = that.getInnerWindowId(_allId)  // 2. 获取滚动事件结束时存在可是区域内的第一个可用Id
            let stype = that.params.stype
            let title = ''
            if (!that.params.desc || that.params.desc == '') {
              title = that.detail.fulltitle
            } else {
              title = that.params.desc
            }
            let desc = that.getNoticeShareDesc(stype, itemID)
            that.shareNotice(stype, itemID, title, desc)
          })
          this.commentList = []
          this.commentinput = false
          this.showComments = false

          this.md5 = this.params.id
        }
      }
    },
    methods: {
      loadcomment: function () {
        if (this.commentList.length == 0) {
          console.log('输出params.id的值')
          console.log(this.params.id)
          this.getCommentList(1, 1, this.params.id)
        }
      },

    idCompute: function (c, i, z) {
      if (!c.title && z == 0) {
        return c.code + '-' + i
      } else {
        let x = parseInt(i) + 1
        return c.code + '-' + x
      }
    },
    nextAnn: function () {
      // console.log(this.annObject)
      for (let i in this.annObject) {
        if (this.annObject[i].id == this.currentIndex) {
          if (i == (this.annObject.length - 1)) {
            let classname = this.annObject[0].id
            let el = document.getElementsByClassName(classname)
            this.currentIndex = classname
            if (el.length > 0) {
              el[0].scrollIntoView()
              $(window).scrollTop($(window).scrollTop() - 80)
            }
            return false
          } else {
            let classname = this.annObject[parseInt(i) + 1].id
            let el = document.getElementsByClassName(classname)
            this.currentIndex = classname
            if (el.length > 0) {
              el[0].scrollIntoView()
              $(window).scrollTop($(window).scrollTop() - 80)
            }
            return false
          }
        }
      }
    },
    prevAnn: function () {
      // console.log(this.annObject)
      for (let i in this.annObject) {
        if (this.annObject[i].id == this.currentIndex) {
          if (i == 0) {
            // alert('3')
            let el = document.getElementsByClassName(this.annObject[this.annObject.length - 1].id)
            this.currentIndex = this.annObject[this.annObject.length - 1].id
            el[0].scrollIntoView()
            $(window).scrollTop($(window).scrollTop() - 80)
            return false
          } else {
            // alert('4')
            let el = document.getElementsByClassName(this.annObject[parseInt(i) - 1].id)
            this.currentIndex = this.annObject[parseInt(i) - 1].id
            el[0].scrollIntoView()
            $(window).scrollTop($(window).scrollTop() - 80)
            return false
          }
        }
      }
    },
    spread: function (e) {
      // console.log(e)
      var tar = e.target
      var $tar = $(tar)
      // console.log($tar.parent())
      $tar.parent().next().css('display', 'inline-block')
      $tar.parent().css('display', 'none')
    },
    retract: function (e) {
      var tar = e.target
      var $tar = $(tar)
      // console.log($tar)
      $tar.parent().prev().css('display', 'inline-block')
      $tar.parent().css('display', 'none')
    },
    readMode: function () {
      function looper () {
        if ($('bdo').length > 0) {
          $('bdo').each(function () {
            $(this).replaceWith($(this).html())
          })
          looper()
        }

      }
      if (this.ModeOPtions == 1) {
        this.ModeOPtions = 2
        looper()
        // console.log(this.annotationList)
      } else {
        this.ModeOPtions = 1
        this.drawAnn()
      }
    },
    getAnn: function (ann) {
      if (ann && ann != 1) {
        // 不展示返回按钮
        this.showNotice = true
      }
      $.ajax({
        url: apiUrl('/V1.0.0/notice/annotationlist'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify({'fromuid': parseInt(this.params.uidUrl), 'md5': this.params.id})
      }).done((response) => {
        if (response.status == 0) {
          if (response.data.length === 0) {
            this.showNotice = true
          }
          this.annObject = response.data
          if (this.annObject.length>0) {
            this.currentIndex = this.annObject[0].id
          }
          this.getDetail()
          if(ann == 0){
            this.readMode()
          } else if(ann == 2){
            this.showNotice = true
            this.drawAnn()
            console.log(this.readORchange)
            console.log(this.showPrevNext)
          } else {

          }
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },

    getTableContent: function (table, startL, endL, spos, epos) {
      // startL 注解起始位置的二维坐标 endL 类似
      let str = ''
        for (let i in table) {
          if (i >= startL.x && i <= endL.x) {
            for (let j in table[i]) {
              if (i === startL.x && j === startL.y) {
                str += table[i][j].substring(spos)
              } else if (i === startL.x && j > startL.y) {
                str += table[i][j]
              } else if (i > startL.x && i < endL.x) {
                str += table[i][j]
              } else if (i === endL.x && j < endL.y) {
                str += table[i][j]
              } else if (i === endL.x && j === endL.y) {
                str += table[i][j].substring(0, epos + 1)
              }
            }
          }
        }
        return str
    },
    drawAnn: function () {
      for (let i in this.annObject) {
        let that = this
        let time = setInterval(function () {
          if (document.getElementById(that.annObject[i].start.code) && document.getElementById(that.annObject[i].end.code) && i > 0 ) {
            that.startpos = ''
            that.endpos = ''
            that.idstart = ''
            that.idend = ''
            // let stext = document.getElementById(item.start.code).innerText.replace(/\n\n/g, '\n')
            // let etext = document.getElementById(item.end.code).innerText.replace(/\n\n/g, '\n')
            that.idStartHTML(document.getElementById(that.annObject[i].start.code).childNodes)
            that.idEndHTML(document.getElementById(that.annObject[i].end.code).childNodes)
            // that.idstart = that.idstart.trim()
            // that.idend = that.idend.trim()
            // console.log(that.idstart)
            // console.log(that.idend)
            function startposRecur (x, p) {
              if (x[p] == '\n') {
                let y = p + 1
                return startposRecur(x, y)
              } else {
                return p
              }
            }
            function endposRecur (x, p) {
              if (x[p] == '\n') {
                let y = p - 1
                return endposRecur(x, y)
              } else {
                return p + 1
              }
            }

           let spos = startposRecur(that.idstart, parseInt(that.annObject[i].start.pos))
           that.getstart(document.getElementById(that.annObject[i].start.code), that.idstart, spos)


            let epos = endposRecur(that.idend,parseInt(that.annObject[i].end.pos))
            that.getend(document.getElementById(that.annObject[i].end.code), that.idend, epos)
            // console.log(that.startNode)
            // console.log(that.startOffset)
            // console.log(that.endNode)
            // console.log(that.endOffset)
            that.annotationContent = that.annObject[i].content
            that.note(that.annObject[i].id, that.annObject[i].typ, that.annObject[i])
            if (i == (that.annObject.length - 1)) {
              that.showPrevNext = true
            }
            window.clearInterval(time)
          } else if (i == 0 && document.getElementById(that.annObject[i].start.code) && document.getElementById(that.annObject[i].end.code)) {
            that.startpos = ''
            that.endpos = ''
            that.idstart = ''
            that.idend = ''
            // let stext = document.getElementById(item.start.code).innerText.replace(/\n\n/g, '\n')
            // let etext = document.getElementById(item.end.code).innerText.replace(/\n\n/g, '\n')
            that.idStartHTML(document.getElementById(that.annObject[i].start.code).childNodes)
            that.idEndHTML(document.getElementById(that.annObject[i].end.code).childNodes)
            // that.idstart = that.idstart.trim()
            // that.idend = that.idend.trim()
            // console.log(that.idstart)
            // console.log(that.idend)
            function startposRecur (x, p) {
              if (x[p] == '\n') {
                let y = p + 1
                return startposRecur(x, y)
              } else {
                return p
              }
            }
            function endposRecur (x, p) {
              if (x[p] == '\n') {
                let y = p - 1
                return endposRecur(x, y)
              } else {
                return p + 1
              }
            }

           let spos = startposRecur(that.idstart, parseInt(that.annObject[i].start.pos))
           that.getstart(document.getElementById(that.annObject[i].start.code), that.idstart, spos)


            let epos = endposRecur(that.idend,parseInt(that.annObject[i].end.pos))
            that.getend(document.getElementById(that.annObject[i].end.code), that.idend, epos)
            // console.log(that.startNode)
            // console.log(that.startOffset)
            // console.log(that.endNode)
            // console.log(that.endOffset)
            that.annotationContent = that.annObject[i].content
            that.note(that.annObject[i].id, that.annObject[i].typ, that.annObject[i])
            window.clearInterval(time)
          }

        }, 100)
      }
    },
    xxetAnn: function () {
      $.ajax({
        url: apiUrl('/V1.0.0/notice/annotationlist'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify({'fromuid': parseInt(this.params.uidUrl), 'md5': this.params.id})
      }).done((response) => {
        if (response.status == 0) {
          // console.log('success')

          this.annObject = []

          // console.log(this.annObject)
          for (let item of response.data) {
            this.startpos = ''
            this.endpos = ''
            this.idstart = ''
            this.idend = ''
            // let stext = document.getElementById(item.start.code).innerText.replace(/\n\n/g, '\n')
            // let etext = document.getElementById(item.end.code).innerText.replace(/\n\n/g, '\n')
            this.idStartHTML(document.getElementById(item.start.code).childNodes)
            this.idEndHTML(document.getElementById(item.end.code).childNodes)
            // this.idstart = this.idstart.trim()
            // this.idend = this.idend.trim()
            // console.log(this.idstart)
            // console.log(this.idend)
            function startposRecur (x, p) {
              if (x[p] == '\n') {
                let y = p + 1
                return startposRecur(x, y)
              } else {
                return p
              }
            }
            function endposRecur (x, p) {
              if (x[p] == '\n') {
                let y = p - 1
                return endposRecur(x, y)
              } else {
                return p + 1
              }
            }

           let spos = startposRecur(this.idstart, parseInt(item.start.pos))
           this.getstart(document.getElementById(item.start.code), this.idstart, spos)


            let epos = endposRecur(this.idend,parseInt(item.end.pos))
            this.getend(document.getElementById(item.end.code), this.idend, epos)
            // console.log(this.startNode)
            // console.log(this.startOffset)
            // console.log(this.endNode)
            // console.log(this.endOffset)
            this.annotationContent = item.content
            this.note(item.id, item.typ, item)
          }

        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    // 遍历
    getstart: function (n, t, pos) {
      // console.log(n)
      // console.log(t)
      // console.log(pos)
      // console.log(this.startpos)
      for (let item of n.childNodes) {

        if (item.nodeName == '#text' && item.data.trim()) {

            // console.log(item.data)
            // console.log(this.startpos.length)
            // console.log(item.data.length)
            if (this.startpos.length >= 0 && this.startpos.length <= pos && this.startpos.length + item.data.length > pos) {
            // console.log(item)
            // console.log('2333')
            this.startNode = item
            this.startOffset = pos - this.startpos.length

          }
          this.startpos = this.startpos + item.data
        }
        if (item.nodeName !== '#text') {
          this.getstart(item, t, pos)
          if (item.nodeName == 'P') {
              this.startpos = this.startpos + '\n'
          }
          if (item.nodeName == 'TD') {
            this.startpos = this.startpos + '\t'
          }
          if (item.nodeName == 'TR') {
            this.startpos = this.startpos + '\n'
          }
      }
        //  else {
        //   this.getstart(item, t, pos)
        // }
      }
    },
    getend: function (n, t, pos) {
      // console.log(n)
      // console.log(t)
      // console.log(pos)
      // console.log(this.endpos)
      for (let item of n.childNodes) {

        if (item.nodeName == '#text' && item.data.trim()) {
            // console.log(item.data)
            // console.log(this.endpos.length)
            // console.log(item.data.length)
          if (this.endpos.length >= 0 && this.endpos.length < pos && this.endpos.length + item.data.length >= pos) {
            // console.log(item.data)
            // console.log('2d33')

            this.endNode = item
            this.endOffset = pos - this.endpos.length

          }
          // console.log(t.indexOf(item.data))
            this.endpos = this.endpos + item.data

        }
        if (item.nodeName !== '#text') {
          this.getend(item, t, pos)
          if (item.nodeName == 'P') {
              this.endpos = this.endpos + '\n'
          }
          if (item.nodeName == 'TD') {
            this.endpos = this.endpos + '\t'
          }
          if (item.nodeName == 'TR') {
            this.endpos = this.endpos + '\n'
          }
        }
      }
    },
    idStartHTML: function (x) {
      for (let item of x) {
        if (item.nodeName == '#text' && item.data.trim()) {
          this.idstart = this.idstart + item.data
        }
        if (item.nodeName !== '#text' && item.nodeName !== 'T') {
          this.idStartHTML(item.childNodes)
          // console.log('12')
          if (item.nodeName == 'P') {
            this.idstart = this.idstart + '\n'
          }
          if (item.nodeName == 'TD') {
            this.idstart = this.idstart + '\t'
          }
          if (item.nodeName == 'TR') {
            this.idstart = this.idstart + '\n'
          }
        }
        if (item.nodeName == 'T') {
          this.idstart = this.idstart + '<t>' + item.outerText + '</t>'
        }

      }
    },
    idEndHTML: function (x) {
      for (let item of x) {
        if (item.nodeName == '#text' && item.data.trim()) {
          this.idend = this.idend + item.data
        }
        if (item.nodeName !== '#text' && item.nodeName !== 'T') {
          // console.log('22')
          this.idEndHTML(item.childNodes)
          if (item.nodeName == 'P') {
            this.idend = this.idend + '\n'
          }
          if (item.nodeName == 'TD') {
            this.idend = this.idend + '\t'
          }
          if (item.nodeName == 'TR') {
            this.idend = this.idend + '\n'
          }
        }
        if (item.nodeName == 'T') {
          this.idend = this.idend + '<t>' + item.outerText + '</t>'
        }
      }
    },
    note: function (x,y, z) {
      if (this.startNode.data == this.endNode.data && this.startNode.parentNode == this.endNode.parentNode) {
        var startIndex = 0
        var endIndex = 0


        if (this.annotationContent) {
          if (x) {
            // let innHtml = this.endNode.parentNode.innerText
            // this.endNode.parentNode.inner = innHtml.substring(0, this.startOffset) + '<bdo>' + innHtml.substring(this.startOffset, this.endOffset) + '</bdo>' + innHtml.substring(this.endOffset)

            let range = document.createRange()
            let newNode = document.createElement("b")
            range.selectNode(this.endNode)
            range.surroundContents(newNode)

            var arr = document.getElementsByTagName('b')[0].innerText.split('')
            // console.log(arr)
            // console.log(document.getElementsByTagName('b')[0])
            arr.splice(this.endOffset, 0, '</bdo>')
            arr.splice(this.startOffset, 0, '<bdo>')
            // console.log(arr.join(''))
            document.getElementsByTagName('b')[0].innerHTML= arr.join('')

            // var p = document.getElementsByTagName('b')[0].parentNode
            // console.log(p.innerHTML)
            // var s = p.innerHTML.replace(/<b>/g, '').replace(/<\/b>/g, '')
            // console.log(s)
            // p.innerHTML = s
            $('b').each(function () {
              $(this).replaceWith($(this).html())
            })

            var bdo = document.getElementsByTagName('bdo')
            // var time = new Date().getTime()
            for (var i = 0;i<bdo.length;i++) {
              var item = bdo[i]
              if (!item.getAttribute('class')) {
                if (y && y == 1) {
                  $(item).addClass('ffyellow')
                }

                // $(item).addClass('y' + time)
                if (y && y == 2) {
                  item.style.background = this.annotationContent
                  if (z.user.uid == this.uid) {
                    $(item).addClass('anyellow')
                  }
                }
                $(item).addClass(x)
              }

            }
            var content = ''
            for (var j = 0;j<document.getElementsByClassName(x).length;j++) {
              var item = document.getElementsByClassName(x)[j]
              content = content + item.innerText
            }
            content = content
            if (y && y == 1) {
              this.annotationContent = this.annotationContent.replace(/\n/g, '<br>')
            }
            this.annotationList[x] = [content, this.annotationContent, y, z.user.showname, z.updtime.substring(0, 10), z.user.uid]
            this.readORchange = true
            this.annotationContent = ''
          }
          // this.annOperation(1, idStartNode.id, idEndNode.id)

        }
      } else {
        if (this.annotationContent) {
          // this.annotationList[time] = [content, this.annotationContent]
          // console.log(this.annotationList)
          if (x) {
            var fNode = this.getParent(this.endNode, this.startNode, this.startNode.parentNode)

            this.flag = false
            this.traversal(fNode)
            // console.log(fNode)
            // fNode.innerHTML = fNode.innerHTML.replace(/<b>/g, '')
            // fNode.innerHTML = fNode.innerHTML.replace(/<\/b>/g, '')
            $('b').each(function () {
              $(this).replaceWith($(this).html())
            })
            var bdo = document.getElementsByTagName('bdo')
            // console.log(bdo)
            // var time = new Date().getTime()
            for (var i = 0;i<bdo.length;i++) {
              var item = bdo[i]
              if (!item.getAttribute('class')) {
                if (y && y == 1) {
                  $(item).addClass('ffyellow')
                }

                // $(item).addClass('y' + time)
                if (y && y == 2) {
                  item.style.background = this.annotationContent
                  if (z.user.uid == this.uid) {
                    $(item).addClass('anyellow')
                  }
                }
                $(item).addClass(x)
              }

            }
            var content = ''
            for (var j = 0;j<document.getElementsByClassName(x).length;j++) {
              var item = document.getElementsByClassName(x)[j]
              content = content + item.innerText
            }
            content = content
            if (y && y == 1) {
              this.annotationContent = this.annotationContent.replace(/\n/g, '<br>')
            }
            this.annotationList[x] = [content, this.annotationContent, y, z.user.showname, z.updtime.substring(0, 10), z.user.uid]
            this.readORchange = true
            this.annotationContent = ''
          }
        }
      }
      // $('.annotationBut').css('display', 'none')
    },
    getParent: function (e, s, parent) {
      // let flag = false
      // let parent = s.parentNode
      // console.log(parent.innerText)
      // console.log(parent)
      // let eIndex = parent.innerHTML.indexOf(e.data)
      // let sIndex = parent.innerHTML.indexOf(s.data)
      // console.log(e.data)
      // console.log(s.data)
      // if (eIndex < 0 || sIndex < 0 || (eIndex == 0 && sIndex == 0)) {
      //   let pn = parent.parentNode
      //   console.log(pn)
      //   return this.getParent(e, s, pn)

      // } else {
      //   return parent
      // }
      let s1 = this.getParentId(s)
      let e1 = this.getParentId(e)
      let s2 = this.getParentId(s1.parentNode)
      let e2 = this.getParentId(e1.parentNode)
      if (s1 == e1) {
        return s1
      } else if (s2 == e2) {
        return s2
      } else {
        return document.getElementById('annotation')
      }
      // for (let item of parent) {
      //   if (item == e) {
      //     return parent
      //   }
      //   if (item.nodeName !== '#text') {

      //   }
      // }

    },
    annotation: function (e) {
      this.currentAnno = []
      this.getBdoClass(e.target)
    },
    // getBdoClass: function (p) {
    //   if (p.nodeName == 'BDO') {
    //     this.seeAnnotation = true
    //     let time = p.className.substring(9)
    //     //
    //     this.currentAnno.push([time, this.annotationList[p.className.substring(9)][1], this.annotationList[p.className.substring(9)][2]])
    //     // this.changedContent.push()
    //     this.getBdoClass(p.parentNode)
    //   }

    // },
    getBdoClass: function (p) {
      if (p.nodeName == 'BDO') {

        let time = p.className.substring(9)
        //
        if (p.className.indexOf('ffyellow') >=0 || p.className.indexOf('anyellow') >= 0) {
          this.seeAnnotation = true
          this.currentAnno.push([time, this.annotationList[p.className.substring(9)][1].substring(3), this.annotationList[p.className.substring(9)][2]])
        }
        // this.changedContent.push()
        this.getBdoClass(p.parentNode)
      }

    },
    traversal: function (n) {
      for (let item of n.childNodes) {
        // if (!this.flag) {
        //   return false
        // }
        if (item == this.startNode) {
          // console.log(this.startNode)
          if (this.startNode.parentNode.outerHTML.indexOf('<t>') < 0) {
            let range = document.createRange()
            let newNode = document.createElement("b")
            range.selectNode(item)
            range.surroundContents(newNode)
            var arr = document.getElementsByTagName('b')[0].innerText.split('')
            // console.log(document.getElementsByTagName('b')[0])
            arr.splice(arr.length, 0, '</bdo>')
            arr.splice(this.startOffset, 0, '<bdo>')
            // console.log(arr)
            document.getElementsByTagName('b')[0].innerHTML= arr.join('')
            // $('b').each(function () {
            //   $(this).replaceWith($(this).html())
            // })
            console.log(item)
          }
          // $('t').each(function () {
          //   $(this).replaceWith('<bdo>' + $(this).html() + '</bdo>')
          // })
          this.flag = true

          // return false
        } else if (item == this.endNode) {
          if (this.endNode.parentNode.outerHTML.indexOf('<t>') < 0) {
            let range = document.createRange()
            let newNode = document.createElement("b")
            range.selectNode(item)
            range.surroundContents(newNode)



            // console.log(item)
            // console.log(document.getElementsByTagName('b'))

            var arr = document.getElementsByTagName('b')[1].innerText.split('')
            // console.log(document.getElementsByTagName('b')[1])
            arr.splice(this.endOffset, 0, '</bdo>')
            arr.splice(0, 0, '<bdo>')
            // console.log(arr)
            document.getElementsByTagName('b')[1].innerHTML= arr.join('')
            // $('b').each(function () {
            //   $(this).replaceWith($(this).html())
            // })
            // console.log(item)
          }
          this.flag = false
          return false
        } else {
          if (this.flag) {
            if (item.nodeName == '#text' && item.data.trim()) {
              let range = document.createRange()
              let newNode = document.createElement("bdo")
              range.selectNode(item)
              range.surroundContents(newNode)
            } else {
              this.traversal(item)
            }
          } else {
            if (item.nodeName !== '#text') {
              this.traversal(item)
            }
          }
        }
      }
    },
    getParentId: function (n) {
      if (!n.id) {
        return this.getParentId(n.parentNode)
      } else {
        return n
      }
    },
    // 返回正文
    backTotext : function () {
      this.showNotice = true
      this.$nextTick(function () {
        this.drawAnn()
      })
    },

    /**
     * 获取公告详情
     */
      getDetail () {
        this.loading = true
        let query = {
          'id': this.params.id,
          'stype': this.params.stype,
          'pdate': this.params.pdate
        }
        if (this.params.pid) {
          query['pid'] = this.params.pid
        }
        query.uid = parseInt(this.params.uidUrl)
        query.share = this.params.share
        query.plat = this.params.plat
        query.sid = this.params.sid
        query.ruid = this.params.ruid
        if (this.params.ext) {
          query['ext'] = this.params.ext
        }
        $.ajax({
          url: apiUrl('/V1.0.0/notice/noticedetail'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query)
        }).done((response) => {
          this.loading = false
          if (response.status === 0) {
            this.showheadtable = response.status
            this.detail = response.data

            this.cpwtotal = this.detail.commentcount
            this.fulltitle = this.detail.fulltitle   // 用于设置分享标题

            let titles = []
            let i = 0
            for (let child of this.detail.child) {
              let isshow = true
              if (child.code && child.code.split('.').length > 3) {
                isshow = false
              }
              let haschild = false
              var rgxp = new RegExp('^' + child.code + '\.\\d+$', 'g')
              if (this.detail.child[i + 1] && this.detail.child[i + 1].code && this.detail.child[i + 1].code.match(rgxp)) {
                haschild = true
              }
              let showchild = false
              if (child.code && child.code.split('.').length <= 2) {
                showchild = true
              }
              titles.push({'title': child.title, 'code': child.code, 'isshow': isshow, 'haschild': haschild, 'showchild': showchild})
              /*
              let idx = 0
              for (let c of child.contents) {
                if (c.htmltag === 'table') {
                  this.heads.push({'info': c.info, 'code': child.code + '-' + idx})
                }
                idx++
              }
              */
              this.allids.push(child.code + '-0')
              let idx = 1
              for (let c of child.contents) {
                this.allids.push(child.code + '-' + idx)
                if (c.htmltag === 'table') {
                  this.heads.push({'info': c.info, 'code': child.code + '-' + idx})
                }
                idx++
              }
              i++
            }
            this.genTitleTree(titles)


            // ----------------------------
            // ------------------------------------------------------ 页头操作 + 微信分享
            this.$nextTick(function () {
              this.toggleHeader()
              // this.changeMetaTitlte()
              this.getwxsign()    // 微信签名
              if (!this.params.tcode) {
                $(window).scrollTop(0)
              }
              // 微信分享
              let _allId = this.getAllId( this.allids )
              let itemID = this.getInnerWindowId(_allId)   // 可视区域内，用于分享描述的id
              let stype = this.params.stype
              let title = ''
              if (!this.params.desc || this.params.desc == '') {
                title = this.detail.fulltitle
              } else {
                title = this.params.desc
              }
              this.changeMetaTitle(title);

              let desc = this.getNoticeShareDesc(stype, itemID)
              this.shareNotice(stype, itemID, title, desc)
              // 子标题定位
              if (this.params.ccode) {  // url中ccode存在且值不为空时
                this.childTitleIntoView(this.params.ccode);
              }
            })


            // ------------------------------------------------------- 分页加载
            //分页数
            let allPageNum = Math.ceil(this.detail.child.length / 5)
            this.allPageNum = allPageNum
            //url中有定位id
            if (this.params.tcode && this.params.tcode !== '' && this.params.tcode !== 'undefined-1') {
              console.log(this.params.tcode)
              let id = this.params.tcode.split('-')[0]
              let idx = 0
              let pages = 0
              let that = this
              //获取包含该tcode的child在数据数组中的位置索引
              for (let i = 0; i < this.detail.child.length; ++i) {
                if (this.detail.child[i].code === id) {
                  idx = i
                  break
                }
              }

              //分享定位id所在的页面
              pages = Math.ceil(idx / 5)
              this.pages = pages
              this.topPage = pages
              this.bottomPage = pages
              console.log(this.pages)

              //将页面滚动到定位位置
              if(this.params.tcode){
                let tcode = this.params.tcode
                setTimeout(function() {
                  if (document.getElementById(tcode)) {
                    console.log(document.getElementById(tcode))
                    console.log(tcode)
                    console.log('详情页面子标题定位')
                    document.getElementById(tcode).scrollIntoView()
                    let scrollTop = $(window).scrollTop() - 30
                    $(window).scrollTop( scrollTop )
                  }
                  // else {
                  //   $(window).scrollTop( 30 )
                  // }
                }, 100);
              }

              console.log(allPageNum)
              let timer = setInterval(function() {
                // 向上分页
                if (that.detail.child.length > 5 && that.topPage > 1) {
                    that.topPage--
                }
                // 向下分页
                if (that.detail.child.length > 5 && that.bottomPage < allPageNum) {
                    that.bottomPage++
                }

                if (that.detail.child.length < 5) {
                  window.clearInterval(timer);
                }
                if (that.topPage == 1 && that.bottomPage == allPageNum) {
                  window.clearInterval(timer);
                  console.log('最后一页 渲染完成')
                  console.log(that.bottomPage)
                  console.log(that.allPageNum)
                }
              }, 100);

              // if (this.detail.child.length <= 5) {
              //   this.getAnn()
              // }
            } else {   // 无id
              // if (this.detail.child.length <= 5) {
              //   this.getAnn()
              // }
              let that = this
              // 计时器  分页加载
              that.topPage = 1
              that.bottomPage = 1
              let timer = setInterval(function() {
                if (that.detail.child.length > 5 && that.bottomPage < allPageNum) {
                  that.bottomPage++
                  // console.log(that.bottomPage)
                } else {
                  window.clearInterval(timer);
                  console.log('最后一页 渲染完成')
                  console.log(that.bottomPage)
                  console.log(that.allPageNum)
                }
              }, 100);

            }
            if (!this.showNotice) {
              let codearr = []
              let existarr = []
              for (let child of this.detail.child) {
                codearr.push(child.code)
              }
              console.log(codearr)
              for (let item of this.annObject) {
                existarr = existarr.concat(codearr.slice(codearr.indexOf(item.start.code.split('-')[0]), codearr.indexOf(item.end.code.split('-')[0]) + 1))
              }
              existarr = [...new Set(existarr)]     // 去重
              console.log(existarr)
              this.newdetail = []
              for (let item of existarr) {
                for (let child of this.detail.child) {
                  if (item === child.code) {
                    this.newdetail.push(child)
                  }
                }
              }
              console.log(this.newdetail)
              this.drawAnn()
            }

          }
        }).fail((response) => {
          this.loading = false
          alert('请求失败')
        })
      },
      indentChild (code) {
        if (code) {
          let len = code.split('.').length - 1
          return {'padding-left': len * 0.8 + 'rem'}
        }
      },
      childTitleIntoView(id) {
        var el = document.getElementById(id);
        var startTime = new Date().getTime();
        if (!el) {
          var interval = setInterval(function() {
            el = document.getElementById(id);
            if (el) {
              el.scrollIntoView();
              clearInterval(interval);
              return;
            }
            if(new Date().getTime() - startTime > 3000){
              clearInterval(interval);
              return;
            }
          }, 100);
        } else {
          el.scrollIntoView()
        }
      },
      getrowspan (rowidx, colidx, mergecells) {
        let key = (rowidx + 1) + '_' + (colidx + 1)
        if (mergecells[key]) {
          return mergecells[key]['row']
        }
        return ''
      },
      getcolspan (rowidx, colidx, mergecells) {
        let key = (rowidx + 1) + '_' + (colidx + 1)
        if (mergecells[key]) {
          return mergecells[key]['col']
        }
        return '';
      },
      toggleHeader () {
        let header = $('.toolsbar-mune')
        if (header.length == 0) {
          header = $('.toolsbar-mune-1')
        }
        let headerH = header.height()
        headerH = headerH?headerH:0;
        let noticeTitleH = $('.notice-title').height()
        let mainCont = $('.my-container')
        if (noticeTitleH > 0) {
          let headerStr = headerH.toString()
          headerStr = Math.ceil(headerStr / 2) + 6
          headerStr = headerStr + 'px'
          mainCont.css({'margin-top': '4.5rem','height':'100%'})

          // 滚动监听
          let p = $(window).scrollTop()  // 滚动条距离顶部的距离
          let t = p
          var that = this
          $(window).off('scroll').on('scroll', function () {   // 绑定滚动的监听事件
            if (($(window).scrollTop() + $(window).height()) >= $(document).height() && that.showComments) {
              let page = that.cpwpage + 1
              if (page <= Math.ceil(that.cpwtotal / 10)) {
                that.getCommentList(page, 1, that.md5)
              }
            }

            p = $(this).scrollTop()  // 滚动后滚动天距顶部的距离
            if (t <= p) {   // 下滚, 隐藏页眉
              if (header.hasClass('slideDown')) {
                header.removeClass('slideDown')
                header.addClass('slideUp')
              } else {
                header.addClass('slideUp')
              }
            } else {    // 上滚， 显示页眉
              if (header.hasClass('slideUp')) {
                header.removeClass('slideUp')
                header.addClass('slideDown')
              } else {
                header.addClass('slideDown')
              }
            }
            t = p
          })
        }
      },

      // 转换板块类型名
      categoryName (category) {
        if (this.categoryMap[category]) {
          return this.categoryMap[category]
        }
        return ''
      },

    },
    watch: {
      'tab1': function (newVal, oldVal) {
        if (newVal === 1) {
          this.titleKeyword = this.headsKeyword
        }
      },
      'windowLocation': function () {
        jQuery(window).unbind()
      }
      // 'showComments': function () {
      //   this.getCommentList(this.md5)
      // }
      // 'commentinput': function () {
      //   this.getCommentList(this.md5)
      // }
    },
    filters: {
      'getrowspan' (rowidx, colidx, mergecells) {
        let key = rowidx + '_' + colidx
        if (mergecells[key]) {
          return mergecells[key]['row']
        }
        return ''
      },
      'getcolspan' (rowidx, colidx, mergecells) {
        let key = (rowidx + 1) + '_' + (colidx + 1)
        if (mergecells[key]) {
          return mergecells[key]['col']
        }
        return ''
      },
    }
  }
</script>

<style scoped>
  /*@import "../../../static/css/style.css";*/
  /*加载*/
  .loading-box {
    top: 43% !important;
  }
  .loading-img {
    width: 35px;
    height: 35px;
    background-image: url('../../../static/images/loading2.gif');
    background-size: cover;
  }

  /* -------------------------------------------- 结构化引导 */
  .new-user-guide {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1999;
    /*background-color: #000000;*/
    /*opacity: .7;*/
    background: rgba(0,0,0, 0.7);
  }

  .guide-img {
    width: 85%;
    margin: 20% auto;
  }

  .guide-img img {
    max-width: 100%;
  }

  .guide-menu {
    position: absolute;
    top: 4px;
    left: 7px;
    width: 34px;
    height: 34px;
    background-color: #FFFFFF;
    border-radius: 5px;
    opacity: .7;
  }
  /* --------------------------------------------------------- 页眉 */
  .toolsbar-mune {
    height: auto;
    min-height: 40px;
    width: 100%;
    max-width: 640px;
    height: auto;
    min-height: 40px;
    position: fixed;
    top: 47px;
    z-index: 2;
    background: #fff;
    box-shadow: -1px 4px 5px 0 rgba(0, 0, 0, 0.06);
  }
    .toolsbar-mune-1 {
    height: auto;
    min-height: 40px;
    width: 100%;
    max-width: 640px;
    height: auto;
    min-height: 40px;
    position: fixed;
    top: 0px;
    z-index: 2;
    background: #fff;
    box-shadow: -1px 4px 5px 0 rgba(0, 0, 0, 0.06);
  }

  .notice-title {
    /*margin-top: 0.45rem;*/
    margin-top:0.35rem;
    width: 88%;
    float: right;
    text-align: left;
    font-size: 0.7rem;
    height: auto;
  }

  .slideUp {
    /* -webkit-transform: translateY(-100px);
         transform: translateY(-100px);*/
    -webkit-transform: translateY(-100px);
    -ms-transform: translateY(-100px);
    -o-transform: translateY(-100px);
    transform: translateY(-100px);
    /*transition: transform .5s ease-out;*/
    -webkit-transition: transform .5s ease-out;
    -o-transition: transform .5s ease-out;
    transition: transform .5s ease-out;
  }
  .slideDown {
    /*-webkit-transform: translateY(0);
        transform: translateY(0);*/
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    -o-transform: translateY(0);
    transform: translateY(0);
    /*transition: transform .5s ease-out;*/
    -webkit-transition: transform .5s ease-out;
    -o-transition: transform .5s ease-out;
    transition: transform .5s ease-out;
  }

  .notice-share-logo {
    display: none;
  }

  .header-toggle-icon {
    width: 84%;
    float: right;
  }

  /*.header-toggle-icon .toggle-icon {*/
    /*background-image: url("../../../static/images/toggle-down-arrow.svg");*/
  /*}*/

  .header-toggle-icon .toggle-icon {
    /*background-image: url("../../../static/images/toggle-down-arrow.svg");*/
    background-size: cover;
    height: 16px;
    width: 21px;
    margin: 0 auto;
  }

  .header-toggle-icon .toggle-up-arrow {
    background-image: url("../../../static/images/toggle-up-arrow.svg");
  }

  .header-toggle-icon .toggle-down-arrow {
    background-image: url("../../../static/images/toggle-down-arrow.svg");
  }

  .toggle-menu-wrap {
    padding: 0;
    width: 11%;
    float: left;
    height: 40px;
    overflow: hidden;
  }

  .header-menu-wrap {
    width: 88%;
    float: right;
    text-align: left;
  }

  .header-menu-wrap .header-menu {
    width: auto;
    margin-left: 35%;
  }

  /* -------------------------------------------------------- 目录*/
  .bottom-color {
    z-index: 1000;
    top: 39px;
    position: fixed !important;
    bottom: 0 !important;
  }

  .caret-pad {
    /*font-size: 14px;*/
    font-size:0.7rem;
    /*float: right;*/
    font-weight: 600;
  }

  .catalog-cont ul li a:active .caret-pad {
    background-color: #d7dbf7;
  }
  /* -------------------------------------------------------- 主体*/
  .notice-content {
    width: 100%;
    margin: 0 auto;
    padding-bottom: 75px;
    overflow: hidden;
  }

  .notice-content .title-b {
    color: #3270ad;
    font-size: 18px;
    font-weight: bold;
  }

  .notice-content .title-b-2 {
    font-size: 18px;
    margin: 20px 0 20px 0;
    font-weight: bold;
  }

  table tr td:first-child::after {
    content: "";
    display: inline-block;
    vertical-align: top;
    min-height: 25px;
  }

  /* td, th {
    font-size: 14px;
  } */

  /*表格*/
  .table-tory-outter {
    overflow-x: scroll;
    /*overflow-y: hidden;*/
    -webkit-overflow-scrolling: touch;
  }

  .table-tory {
    width: 860px !important;
    min-width: 100%;
  }

  .table-tory tbody >.oldcom {
    background-color: #e4e4e4;
  }

  .table-tory tbody >.evencom {
    background-color: #ffffff;
  }

  .table-tory tr, .table-tory td {
    border-top: 1px solid #333333;
    border-left: 1px solid #333333;
    line-height: 2em;
    padding: 2px 4px;
    text-align: left;
    vertical-align: middle;
    min-width: 100px;
    max-width: 50%;
    overflow-wrap: break-word;
    word-break: break-all;
    font-size: 14px !important;
  }

  /* Mobile browsers only */
  @media only screen and (max-device-width: 480px) {
    td {
      -webkit-text-size-adjust:100%;
      -moz-text-size-adjust:100%;
      -ms-text-size-adjust:100%;
    }
  }

  .catalog-cont {
    padding: 0.5rem;
    padding-bottom: 3rem;
  }

  .catalog-cont ul li {
    padding: 0;
    overflow: hidden;
    line-height: 28px;
  }

  .catalog-cont ul li > .expand {
    color: #3270ad;
  }
  .catalog-cont ul li a {
    color: #000;
  }

  .title-a {
    font-weight: bold;
    font-size: 0.8rem;
    margin-bottom: 10px;
    background: linear-gradient(to right, #d9d9d9, #ffffff);
    line-height: 1.5em;
    padding: 2px 0;
    text-indent: 1px;
    padding-left: 3% !important;
    margin: 0px !important;
  }
  .title-b {
    text-indent: 1px;
    font-size: 16px !important;
    padding-left: 3% !important;
  }
  .title-b-2 {
    padding-left: 0px !important;
    text-indent: 0;
    font-size: 16px !important;
    width: 94%;
    margin: 0 auto !important;
  }

  /* --------------------------------------------------- 页脚*/
  .my-container {

    margin-top: 1rem;
    top: 0;
  }
  .footer-app {
    z-index: 1001 !important;
  }

  .footer-btn {
    /*font-size: 15px;*/
    padding: 0px 3px !important;
  }

  /*-----------------------------------------*/
  .toolsbar-mune-2 {
    height: auto;
    min-height: 40px;
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 2;
    background: #fff;
    box-shadow: -1px 4px 5px 0 rgba(0, 0, 0, 0.06);
  }

  .toggle-menu-wrap-2 {
    padding: 0;
    width: 11%;
    float: left;
    height: 40px;
    overflow: hidden;
  }

  .header-menu-wrap-2 {
    width: 88%;
    float: right;
    text-align: left;
  }

  .header-menu-wrap-2 .header-menu {
    width: auto;
    margin-left: 35%;
  }

  .hide-slidebar::-webkit-scrollbar {
    display: none
  }

  .modal {
    display: block;
  }

  table{
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    user-select: none;
  }
  .ffyellow{
    border-bottom: 2px solid red;
    cursor: pointer;
  }

  .anyellow{
    cursor: pointer;
  }
  .my-container-1{
    bottom: 0.5rem;
    position: absolute;
    overflow: auto;
    width: 100%;
    max-width: 640px;
    top: 81px;
    height:100%
  }
  .my-container-3{
    bottom: 0.5rem;
    position: absolute;
    overflow: auto;
    width: 100%;
    max-width: 640px;
    top: 60px;
    height:100%
  }
</style>



/** WEBPACK FOOTER **
 ** MyNoticeDetail.vue?67c4bc65
 **/